module.exports = __webpack_public_path__ + "./img/close-icon.c30463a597e914039697d587f8f6e987.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-chat-window/es/assets/close-icon.png
// module id = ./node_modules/react-chat-window/es/assets/close-icon.png
// module chunks = 0